import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import DateDialog from '../DateDialog/DateDialog';
import template from './DateTimeDialog.html?raw';
// NOTE (JS2TS): dropped dead deps: dojo/aspect, dojo/number (not used); more/SelectBox (imported but never
// used in code and not referenced in DateTimeDialog.html). xstyle/css!./OccurrenceForm.css was already commented out.

class DateTimeDialog extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    _timeArray: any = [];
    _timeSelects: any = [];
    _dateDialog: any = null;
    _useTime = true;
    _checkFunction: any = null;

    value: any = null;

    _timeDropdownState = "collapsed";

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;
    }

    startup(): void {

        var dateTime = new Date();

        // heutiges Datum setzen
        if (this.value == null) {
            this.presetValue(dateTime, dateTime);
        } else {
            if (this._useTime === true) {
                var values = this.value.split(" ");
                console.log("startup preset", values);
                if (values.length == 2) {
                    this.presetValue(values[0], values[1]);
                }
            }
            else {
                this.presetValue(this.value);
            }
        }

        dateTime.setMinutes(0);
        dateTime.setHours(0);
        dateTime.setSeconds(0);
        var currentDay = dateTime.getDate();


        // jetzt für jede 15 Minuten ein Eintrag ins Array
        this._timeArray = [];

        while (dateTime.getDate() == currentDay) {
            var hour = dateTime.getHours();
            var minutes = dateTime.getMinutes();

            var options: any = { hour: '2-digit', minute: '2-digit' };
            var time = dateTime.toLocaleString('de-DE', options);

            this._timeArray.push(time);

            dateTime = new Date(dateTime.getTime() + 15 * 60000); // 15 Minuten dazu
        }

        //console.log(this._timeArray);
    }

    presetValue(date: any, time?: any): void {
        //console.log("presetValue", date, time, this._useTime);
        if (typeof (date) == "string") {

            this.inputDate.value = date;
            //console.log("date is string", date, this.inputDate.value);

        } else if (typeof (date) == "object") {
            var options: any = { day: '2-digit', month: '2-digit', year: "numeric" };
            var datestring = date.toLocaleString('de-DE', options);
            this.inputDate.value = datestring;
        }

        if (this._useTime === true) {
            if (typeof (time) == "string") {
                this.inputTime.value = time;
                // console.log("time is string", time, this.inputTime.value);
            } else if (typeof (time) == "object") {
                var options: any = { hour: '2-digit', minute: '2-digit' };
                var timestring = time.toLocaleString('de-DE', options);
                this.inputTime.value = timestring;
            }
        }

        this.setOutputValue();

    }

    _setUseTimeAttr(value: any): void {

        this._useTime = value === true;

        //console.log("_setUseTimeAttr", value, this._useTime);
        if (this._useTime === true) {
            domClass.remove(this.sectionTime, "w3-hide");
        } else {
            domClass.add(this.sectionTime, "w3-hide");
        }
    }

    _onClick_Close(): void {
        this.close(0);
    }
    _onClick_Button_Cancel(evt?: any): void {
        this.close(0);
    }
    _onClick_Button_OK(evt?: any): void {
        this.close(1);
    }

    _setCallbackAttr(value: any): void {
        this.callback = value;
    }

    _onKeyUp_Dlg(evt: any): void {
        if (evt.keyCode == 13) {
            this.close(1);
        }
        if (evt.keyCode == 27) {
            this.close(0);
        }
    }

    _constructDateDialog(): void {
        var datePicker = new DateDialog();
        this._dateDialog = datePicker;
        datePicker.set("CloseAfterSelect", false);
        //domStyle.set(datePicker.domNode, "position", "absolute");
        //domStyle.set(datePicker.domNode, "z-index", "100");
        //domClass.add(datePicker.domNode, "w3-white");
        domConstruct.place(datePicker.domNode, this.datePickerNode);

        var setDate = lang.hitch(this, function (type: any, date: any, selectedDates: any) {
            //console.log("setDate", type, date, selectedDates);
            if (type == "add") {
                this.inputDate.value = date;
                this.setOutputValue();
            }
        });

        datePicker.set("callback", setDate);

        datePicker.show();
    }

    show(heading?: any): void {
        this._constructDateDialog();

        if (typeof (heading) == "string") {

        } else {
            var heading: any = "Datum und Uhrzeit wählen";
        }
        domAttr.set(this.headerNode, "innerHTML", heading);
        domStyle.set(this.modalDlg, "display", "block");

        this.startup();

    }

    close(result?: any): void {
        domStyle.set(this.modalDlg, "display", "none");

        if (typeof (result) == "undefined") {
            result = 0;
        }

        var dateTime = this.value;

        if (this.inputTime.value == null && this._useTime === true || this.inputDate == null) {
            result = 0;
            dateTime = null;
        }

        if (this.checkTimeInput() != true) {
            result = 0;
            dateTime = null;
        }

        //console.log(result, dateTime);


        // weitere Parameter zurückgeben, zB. Textinput?
        //
        setTimeout(lang.partial(this.callback, result, dateTime), 1);

        //this._dateDialog.destroy();
        //  selbstzerstörung in 1 Sekunde :-)
        //
        setTimeout(lang.hitch(this, "destroy"), 1000);
    }

    createTimeSelects(compareString?: any): void {
        domConstruct.empty(this.timeSelectDropdownContainer);

        for (var i = 0; i < this._timeArray.length; i++) {
            var time = this._timeArray[i];
            var bCreate = true;

            if (typeof (compareString) == "string") {
                bCreate = false;
                if (time.startsWith(compareString)) {
                    bCreate = true;
                }
            }

            if (bCreate === true) {
                var select = domConstruct.create("div", {
                    innerHTML: time,
                    className: "w3-padding mds-hover-dark"
                }, this.timeSelectDropdownContainer);

                if (this.inputTime.value == time) {
                    domClass.add(select, "w3-blue");
                } else if (time.endsWith(":00")) {
                    domClass.add(select, "w3-2018-quiet-gray");
                }

                on(select, "click", lang.hitch(this, "_onSelect_TimeFromDropdown", time));
                on(select, "keyUp", lang.hitch(this, "_onKeyUp_TimeFromDropdown", time));
            }

        }
    }

    _onSelect_TimeFromDropdown(time: any): void {
        //console.log("select:", time);
        this.inputTime.value = time;
        this.setOutputValue();
        this.collapseTimeDropdown();
    }

    _onKeyUp_TimeFromDropdown(time: any, evt?: any): void {
        console.log("key:", time, evt);
    }

    _onClick_timeInput(evt: any): void {
        if (this._timeDropdownState != "expanded") {
            this.createTimeSelects();
        }
        this.toggleTimeDropdown("expanded");
        evt.stopPropagation();
    }

    _onClick_timePickerRow(evt: any): void {
        if (this._timeDropdownState != "expanded") {
            this.createTimeSelects();
        }
        this.toggleTimeDropdown();
    }

    toggleTimeDropdown(targetState?: any): void {
        if (targetState === "expanded" || targetState === true) {
            this.expandTimeDropdown();
        } else if (targetState === "collapsed" || targetState === false) {
            this.collapseTimeDropdown();
        } else {
            if (this._timeDropdownState === "collapsed") {
                this.expandTimeDropdown();
            } else {
                this.collapseTimeDropdown();
            }
        }
    }

    expandTimeDropdown(): void {
        domClass.remove(this.timeSelectDropdownContainer, "w3-hide");

        this._timeDropdownState = "expanded";
    }

    collapseTimeDropdown(): void {
        domClass.add(this.timeSelectDropdownContainer, "w3-hide");

        this._timeDropdownState = "collapsed";

        // input prüfen und auf Value schreiben
        this.checkTimeInput();
    }

    checkTimeInput(): any {
        var regex = RegExp("^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$");

        if (this._useTime !== true) {
            return true; // passt scho
        }
        else if (this.inputTime == null) {

        }
        else if (regex.test(this.inputTime.value) === true) {
            domClass.remove(this.messageNode, "w3-text-red");
            domClass.remove(this.inputTime.parentNode, "w3-border-red");
            this.setOutputValue();
            return true;
        } else {
            domClass.add(this.messageNode, "w3-text-red");
            domClass.add(this.inputTime.parentNode, "w3-border-red");
            this.messageNode.innerHTML = "ungültige Zeitangabe!";
            return false;
        }
    }

    _onKeyUp_TimeInput(evt: any): void {

        if (this._checkFunction != null) {
            clearTimeout(this._checkFunction);
        }

        evt.stopPropagation();

        if (evt.keyCode == 13) { // Enter
            this.collapseTimeDropdown();

        }
        else if (evt.keyCode == 27) { // escape
            this.collapseTimeDropdown();
        }

        else {
            this._checkFunction = setTimeout(lang.hitch(this, "checkTimeInput"), 800);

            this.createTimeSelects(this.inputTime.value);
            this.expandTimeDropdown();
        }
    }

    setOutputValue(): void {
        var dateTime = "";

        if (this._useTime === true) {
            dateTime = this.inputDate.value + " " + this.inputTime.value;
        } else {
            dateTime = this.inputDate.value + " " + this.inputTime.value;
        }

        this.value = dateTime;

        this.messageNode.innerHTML = "Gewählt: " + this.value;
    }

}
DateTimeDialog.prototype.declaredClass = 'more.DateTimeDialog';

export default mdsWidget(DateTimeDialog);
